// navbar
export const SET_NAVBAR = 'set_navbar'



// WEBPACK FOOTER //
// ./src/actions/types.js